	          // The booking page has two captcha widgets (reservation and contact
	          // forms) that share element ids, so every lookup is scoped to its form.
	          function bwCaptchaEl(form, id) {
	              return form.querySelector('#' + id + ', #' + id + '-contact');
	          }
	          function bwGenerateCaptcha(form) {
	              const num1 = Math.floor(Math.random() * 10) + 1;
	              const num2 = Math.floor(Math.random() * 10) + 1;
	              bwCaptchaEl(form, 'captcha-num1').textContent = num1;
	              bwCaptchaEl(form, 'captcha-num2').textContent = num2;
	              bwCaptchaEl(form, 'captcha-answer').value = '';
	              bwClearCaptchaError(form);
	          }
	          function bwShowCaptchaError(form, message) {
	              const errorElement = bwCaptchaEl(form, 'captcha-error');
	              if (errorElement) {
	                  errorElement.textContent = message;
	                  errorElement.style.display = 'block';
	              }
	          }
	          function bwClearCaptchaError(form) {
	              const errorElement = bwCaptchaEl(form, 'captcha-error');
	              if (errorElement) {
	                  errorElement.style.display = 'none';
	                  errorElement.textContent = '';
	              }
	          }
	          function bwValidateCaptcha(form) {
	              const num1 = parseInt(bwCaptchaEl(form, 'captcha-num1').textContent, 10);
	              const num2 = parseInt(bwCaptchaEl(form, 'captcha-num2').textContent, 10);
	              const userAnswer = parseInt(bwCaptchaEl(form, 'captcha-answer').value, 10);
	              return userAnswer === num1 + num2;
	          }
const testCardData = {
    test: [
        {
            custname: "Jacob S",
            rating: "4.5",
            comment: "Loved the peaceful location and the scenic views. Rooms were clean, staff friendly, and the morning mist was magical. Highly recommended for couples and families."
        },
        {
            custname: "Albert",
            rating: "3.7",
            comment: "Great value for money. The location is close to key attractions and the staff helped us plan our day trips. Parking and WiFi were reliable."
        },
        {
            custname: "Priya Nair",
            rating: "3.7",
            comment: "Great value for money. The location is close to key attractions and the staff helped us plan our day trips. Parking and WiFi were reliable."
        }
    ]
};
   function renderTestimonial( ) {
		const testCardsContainer = document.getElementById('reviews-grid');
		if (!testCardsContainer) return; // pages without the reviews block (search, 404, reciprocal)
		const cardHTMLArray = [];
		const testim = testCardData.test;
 		for (let i = 0; i < testim.length; i++) {
			const review = testim[i];
			var html=createReviewCard(review);
			cardHTMLArray.push(html);
		}
	    testCardsContainer.innerHTML = cardHTMLArray.join('');
   }
  function createReviewCard(review) {
      const custname = review.custname || '#';
      const rating = review.rating || '#';
      const comment = review.comment || '#';
     return `
                            <div class="review-card">
                                <div class="reviewer-info">
                                    <div class="reviewer-details">
                                        <div class="name">${custname} (${rating} ) <i class="fas fa-star my-star-icon" id="top-star"></i> </div>
                                        <div class="rating-row">
                                            <span class="stars" role="img" aria-label="5 out of 5 stars">
                                                <i class="fas fa-star my-star-icon"></i>
                                                <i class="fas fa-star my-star-icon"></i>
                                                <i class="fas fa-star my-star-icon"></i>
                                                <i class="fas fa-star my-star-icon"></i>
                                                <i class="fas fa-star my-star-icon"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <p class="review-text">${comment}</p>
                            </div>
     `;
 }
document.addEventListener('DOMContentLoaded', renderTestimonial);
      document.addEventListener("DOMContentLoaded", function () {
        const imgWrapper = document.querySelector(
          ".col-lg-6 > div:first-child > div:first-child"
        );
        const leftArrow = document.querySelector(".image-nav-left");
        const rightArrow = document.querySelector(".image-nav-right");
        let currentImageIndex = 0;
        const imageCount = 2; 
        function updateImage(direction) {
          if (direction === "next") {
            currentImageIndex = (currentImageIndex + 1) % imageCount;
          } else {
            currentImageIndex =
              (currentImageIndex - 1 + imageCount) % imageCount;
          }
          imgWrapper.style.transform = `translateX(-${
            currentImageIndex * 100
          }%)`;
        }
		if (leftArrow !== undefined && leftArrow  && rightArrow !== undefined && rightArrow)
		{
					leftArrow.addEventListener("click", function () {
					  updateImage("prev");
					});
					rightArrow.addEventListener("click", function () {
					  updateImage("next");
					});
					leftArrow.addEventListener("mouseenter", function () {
					  this.style.backgroundColor = "rgba(0,0,0,0.8)";
					  this.style.transform = "translateY(-50%) scale(1.1)";
					});
					leftArrow.addEventListener("mouseleave", function () {
					  this.style.backgroundColor = "rgba(0,0,0,0.6)";
					  this.style.transform = "translateY(-50%) scale(1)";
					});
					rightArrow.addEventListener("mouseenter", function () {
					  this.style.backgroundColor = "rgba(0,0,0,0.8)";
					  this.style.transform = "translateY(-50%) scale(1.1)";
					});
					rightArrow.addEventListener("mouseleave", function () {
					  this.style.backgroundColor = "rgba(0,0,0,0.6)";
					  this.style.transform = "translateY(-50%) scale(1)";
					});
			}
      });
	          document.addEventListener('DOMContentLoaded', function() {
	              ['myForm', 'contact-form'].forEach(function(formId) {
	                  const form = document.getElementById(formId);
	                  if (!form || !bwCaptchaEl(form, 'captcha-answer')) return;
	                  bwGenerateCaptcha(form);
	                  const refresh = bwCaptchaEl(form, 'refresh-captcha');
	                  if (refresh) {
	                      refresh.addEventListener('click', function() {
	                          bwGenerateCaptcha(form);
	                      });
	                  }
	                  bwCaptchaEl(form, 'captcha-answer').addEventListener('input', function() {
	                      bwClearCaptchaError(form);
	                  });
	                  form.addEventListener('submit', function(e) {
	                      if (!bwValidateCaptcha(form)) {
	                          e.preventDefault();
	                          bwShowCaptchaError(form, 'Please enter the correct answer for the security verification.');
	                          bwCaptchaEl(form, 'captcha-answer').focus();
	                      }
	                  });
	              });
	          });

// Live character counters for the hints under long text fields (<span class="bw-count" data-for="hint-id">)
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bw-count[data-for]').forEach(function (counter) {
    var field = document.querySelector('[aria-describedby="' + counter.getAttribute('data-for') + '"]');
    if (!field) return;
    var update = function () { counter.textContent = field.value.length; };
    field.addEventListener('input', update);
    update();
  });
});
